interface AnsweredCellSource {
    answerText?: string;
    filesCount?: number;
}

export const isCellAnswered = (
    answerType: string,
    fileAnswerType: string,
    cell: AnsweredCellSource
): boolean => {
    if (answerType === fileAnswerType) {
        return (cell.filesCount ?? 0) > 0;
    }

    return (
        cell.answerText !== undefined &&
        cell.answerText !== null &&
        cell.answerText !== ''
    );
};
